import React, { useState, useEffect } from 'react';
import Breadcrumb from '../Components/Breadcrumb';
import Pagehelmet from '../Components/Pagehelmet';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const MyOrders = () => {
    const navigate = useNavigate();
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [orders, setOrders] = useState([]); // New state for orders

    const [profileData, setProfileData] = useState({
        address: "",
        email: "",
        emergencyContact: "",
        familyMembers: "",
        firstName: "",
        lastName: "",
        phone: "",
        preferences: "",
        role: ""
    });

    // Fetch user data and orders
    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);

                // 1. Fetch user data from localStorage
                const userData = localStorage.getItem('User_Info');
                if (userData) {
                    const parsedData = JSON.parse(userData);
                    const { _id } = parsedData
                    setProfileData(parsedData);

                    // 2. Fetch orders from API
                    const response = await axios.post(
                        `${process.env.REACT_APP_API_URL}/orders/view-order-by-id`,
                        {
                            "id": _id
                        },
                        {
                            headers: {
                                Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`,
                            }
                        }
                    );

                    setOrders(response.data);
                } else {
                    setError("No user data found");
                    setTimeout(() => navigate('/'), 2000);
                }
            } catch (err) {
                setError("Failed to load data");
                console.error("Error loading data:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [navigate]);

    // ... keep all your existing functions (handleChange, handleSubmit, handleLogout)

    if (loading) {
        return (
            <div className="container text-center py-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <div>
            <Pagehelmet pageTitle="My Orders" />
            <Breadcrumb title="My Orders" />

            <section className="profile-section py-5">
                <div className="container">
                    <div className="row">
                        {/* Left column with profile info (keep existing) */}
                        <div className="col-lg-4 mb-4">
                            {/* ... your existing profile card ... */}
                        </div>

                        {/* Right column with forms and orders */}
                        <div className="col-lg-8">
                            <div className="card p-4 mb-4">
                                {/* ... your existing profile form ... */}
                            </div>

                            {/* New Orders Section */}
                            <div className="card p-4">
                                <h3 className="mb-4">My Orders</h3>

                                {orders.length === 0 ? (
                                    <div className="alert alert-info">No orders found</div>
                                ) : (
                                    <div className="table-responsive">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th>Order ID</th>
                                                    <th>Event</th>
                                                    <th>Date</th>
                                                    <th>Amount</th>
                                                    <th>Status</th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {orders.map(order => (
                                                    <tr key={order.id}>
                                                        <td>{order.tx_ref || order.id}</td>
                                                        <td>{order.event?.name || 'N/A'}</td>
                                                        <td>{new Date(order.createdAt).toLocaleDateString()}</td>
                                                        <td>{order.totalAmount?.toFixed(2)} ETB</td>
                                                        <td>
                                                            <span className={`badge ${order.status === 'completed' ? 'bg-success' :
                                                                    order.status === 'pending' ? 'bg-warning' : 'bg-secondary'
                                                                }`}>
                                                                {order.status}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <button
                                                                className="btn btn-sm btn-outline-primary"
                                                                onClick={() => navigate('/OrderDetails', {
                                                                    state: {
                                                                        order: order

                                                                    }
                                                                })}
                                                            >
                                                                View
                                                            </button>

                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default MyOrders;